import React, { createElement } from 'react';
import StickerBackground, {
  EStickerVariants,
} from '@monofront/design-system/visuals/Backgrounds/StickerBackground';

interface IBubble {
  title: string | React.ReactNode;
  text: string | React.ReactNode;
  variant?: EStickerVariants;
  height?: number;
  width?: number;
  backgroundColor?: string;
  fontColor?: string;
}

const TextWrapper = ({ tag = 'p', className = '', children }) => {
  const wrapper = typeof children === 'string' ? tag : 'div';

  return createElement(wrapper, { className: className }, children);
};

const Bubble: React.FC<IBubble> = ({
  title,
  text,
  variant,
  height,
  width,
  backgroundColor,
  fontColor,
}) => (
  <>
    <div className="tw-relative tw-flex tw-items-center tw-justify-center">
      <StickerBackground
        color={backgroundColor}
        height={height}
        width={width}
        variant={variant}
      />
      <div className="text-wrapper tw-absolute tw-left-1/2 tw-top-1/2 tw-w-full tw-max-w-full -tw-translate-x-1/2 -tw-translate-y-1/2 tw-transform tw-flex-col tw-p-6 tw-text-center">
        <TextWrapper
          tag="h2"
          className="text tw-w-full tw-font-title tw-text-4xl tw-font-bold md:tw-text-5xl [&>*]:tw-font-title [&>*]:tw-text-4xl [&>*]:tw-font-bold md:[&>*]:tw-text-5xl"
        >
          {title}
        </TextWrapper>

        <TextWrapper
          tag="p"
          className="text tw-font-semibold md:tw-text-lg md:[&>*]:tw-text-lg"
        >
          {text}
        </TextWrapper>
      </div>
    </div>
    <style jsx>{`
      .text-wrapper :global(.text),
      .text-wrapper :global(.text > *) {
        color: ${fontColor ? fontColor : '#000'};
      }
    `}</style>
  </>
);

export default Bubble;
